import { createSlice } from "@reduxjs/toolkit";
import { fetchContraRecord } from "./contraRecordThunk";

const initialState = {
  list: [],
  listWithDetails: [],
  loading: false,
  filters: {
    filterType: "All",
    customerId: null,
    locationId: null,
    userId: null,
    fromDate: null,
    toDate: null,
  },
};

const contraRecordSlice = createSlice({
  name: "contraRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContraRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchContraRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchContraRecord.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = contraRecordSlice.actions;
export default contraRecordSlice.reducer;
